import { IconMap, IconTypes, theme } from 'aimo-ui';
import React from 'react';
import { isWeb } from 'utils/deviceUtils';

// Only import SvgFromUri when not on web
let SvgFromUri: any = null;
if (!isWeb) {
  // Dynamic import to avoid the error in web environment
  const RNSvg = require('react-native-svg');
  SvgFromUri = RNSvg.SvgFromUri;
}

const EmptyImage = () => <></>;

const sizes = theme.iconSizes;
export type SvgName = keyof typeof IconMap;

type SvgProps = {
  name: SvgName;
  height?: number;
  width?: number;
  testID?: string;
  align?: 'center' | 'flex-start';
  size?: keyof typeof sizes;
  uri?: string;
};

const SvgUrl: React.FC<IconTypes & SvgProps> = ({
  uri,
  width,
  height,
  align,
  color,
  ...rest
}) => {
  if (isWeb) {
    return (
      <img
        width={width}
        height={height}
        src={uri}
        style={{ alignSelf: align }}
        alt=""
        draggable={false}
      />
    );
  }
  return (
    <SvgFromUri
      fill={color}
      width={width}
      height={height}
      uri={uri as string}
      {...rest}
    />
  );
};

const SvgImage: React.FC<IconTypes & SvgProps> = ({
  name,
  height,
  width,
  align = 'center',
  style,
  color = theme.colors.transparent,
  size,
  preserveAspectRatio = 'xMidYMin meet',
  uri,
  ...rest
}) => {
  const numericSize = size ? sizes[size] : undefined;
  if (uri) {
    return (
      <SvgUrl
        uri={uri}
        name={name}
        width={numericSize ?? width}
        height={numericSize ?? height}
        fill={color}
        align={align}
        {...rest}
      />
    );
  }
  const ReturnedImage: React.FC<IconTypes> = IconMap[name] || EmptyImage;
  return (
    <ReturnedImage
      style={{ alignSelf: align }}
      name={name}
      width={numericSize ?? width}
      height={numericSize ?? height}
      fill={color}
      preserveAspectRatio={preserveAspectRatio}
      {...rest}
    />
  );
};

export default SvgImage;
